import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteApiCodelistManagementFiles } from "Infrastructure/Api/Api";
import { useSnackbar } from "Infrastructure/Providers/SnackbarProvider/SnackbarProvider";
import { CODELIST_FILES_QUERY_KEY } from "../Queries/useCodeListFilesQuery";

type DeleteParams = {
	folderPath: string;
	fileName: string;
};

export function useDeleteCodeListFileMutation() {
	const queryClient = useQueryClient();
	const showSnackbar = useSnackbar();

	return useMutation({
		mutationFn: (params: DeleteParams) =>
			deleteApiCodelistManagementFiles(params.folderPath, params.fileName),
		onSuccess: (response) => {
			if (response.status === 200) {
				showSnackbar(
					`Soubor byl smazán (${response.data.deletedVersions} verzí)`,
					"success",
				);
				queryClient.invalidateQueries({ queryKey: [CODELIST_FILES_QUERY_KEY] });
			} else if (response.status === 404) {
				showSnackbar("Soubor nebyl nalezen", "error");
			} else {
				showSnackbar("Chyba při mazání souboru", "error");
			}
		},
		onError: () => {
			showSnackbar("Chyba při mazání souboru", "error");
		},
	});
}
